import React, { FC } from 'react';
import './FrameView.css';
import { useVideoURL } from '@/Shared/Logic/Hooks/TechnicalHooks';

interface FrameViewProps {
	fade?: boolean;
	url: string;
}

const FrameView: FC<FrameViewProps> = ({ url }) => {
	const { getYoutubeEmbededURL } = useVideoURL();

	return (

		<iframe
			data-testid="FrameView"
			className={`FrameView `}
			src={getYoutubeEmbededURL(url)}
			title="YouTube video player"
			frameBorder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerPolicy="strict-origin-when-cross-origin"
			allowFullScreen>
		</iframe>
	);
}

export default FrameView;